import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WelcomePage from "./pages/WelcomePage/WelcomePage";
import { LanguageProvider } from "./Context/LanguageContext";
import Experiences from "./pages/Experiences/Experiences";
import Education from "./pages/Education/Education";
import Courses from "./pages/Courses/Courses";
import Projects from "./pages/Projects/Projects";
import Volunteering from "./pages/Volunteering/Volunteering";
import ExtraInfo from "./pages/ExtraInfo/ExtraInfo";
import MainPage from "./pages/MainPage/MainPage";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<MainPage />}>
              <Route path="/" element={<WelcomePage />} />
              <Route path="experiences" element={<Experiences />} />
              <Route path="education" element={<Education />} />
              <Route path="courses" element={<Courses />} />
              <Route path="projects" element={<Projects />} />
              <Route path="volunteering" element={<Volunteering />} />
              <Route path="extra-info" element={<ExtraInfo />} />
            </Route>
          </Routes>
          <Footer />
        </Router>
      </LanguageProvider>
    </div>
  );
}

export default App;
